import Router from './router';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: '14px',
            background: '#0f172a',
            color: '#f8fafc',
            fontSize: '14px',
            padding: '12px 16px',
            boxShadow: '0 24px 48px -24px rgba(15, 23, 42, 0.55)',
          },
          success: { iconTheme: { primary: '#34d399', secondary: '#0f172a' } },
          error: { iconTheme: { primary: '#fb7185', secondary: '#0f172a' } },
        }}
      />
      <Router />
    </>
  );
}

export default App;
